<template>
  <div>
    <b-modal
      id="modal-save-manager"
      ref="saveModal"
      title="Save / Load Game"
      size="lg"
      @show="refreshSaves"
      hide-footer
    >
      <b-alert show variant="info" class="mb-2">
        <small><strong>Auto-save is enabled.</strong> Your current session is automatically saved and will be restored when you return.</small>
      </b-alert>
      <b-alert show variant="warning" class="mb-3">
        <small>Saves are stored in your browser's local storage. They will be deleted if you clear your browser data and are not available on different browser/device.</small>
      </b-alert>

      <b-card no-body class="mb-3">
        <b-card-header>Create New Save</b-card-header>
        <b-card-body>
          <b-form inline @submit.prevent="createSave">
            <b-form-input
              v-model="newSaveName"
              placeholder="Enter save name..."
              class="mr-2 flex-grow-1"
            ></b-form-input>
            <b-button variant="success" @click="createSave" :disabled="!newSaveName.trim()">
              Save Game
            </b-button>
          </b-form>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-3">
        <b-card-header class="d-flex justify-content-between align-items-center">
          <span>Saved Games</span>
          <b-button variant="warning" size="sm" @click="resetToDefault">
            Reset to Default
          </b-button>
        </b-card-header>
        <b-card-body>
          <div v-if="saves.length === 0" class="text-muted text-center py-3">
            No saved games yet. Create your first save above.
          </div>
          <b-list-group v-else>
            <b-list-group-item
              v-for="save in saves"
              :key="save.id"
              class="d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{{ save.name }}</strong>
                <br>
                <small class="text-muted">{{ save.date }}</small>
              </div>
              <div>
                <b-button variant="primary" size="sm" class="mr-2" @click="loadSave(save.id)">
                  Load
                </b-button>
                <b-button variant="danger" size="sm" @click="deleteSave(save.id)">
                  Delete
                </b-button>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card-body>
      </b-card>

      <div class="text-right">
        <b-button variant="secondary" @click="closeModal">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'SaveManager',
  data() {
    return {
      newSaveName: '',
      saves: []
    }
  },
  methods: {
    refreshSaves() {
      this.saves = this.$store.getters.getAllSaves()
    },
    createSave() {
      if (!this.newSaveName.trim()) return
      this.$store.commit('saveState', this.newSaveName.trim())
      this.newSaveName = ''
      this.refreshSaves()
    },
    loadSave(saveId) {
      this.$store.commit('loadState', saveId)
      this.$bvModal.hide('modal-save-manager')
    },
    deleteSave(saveId) {
      if (confirm('Are you sure you want to delete this save?')) {
        this.$store.commit('deleteSave', saveId)
        this.refreshSaves()
      }
    },
    resetToDefault() {
      if (confirm('Are you sure you want to reset to default state? Current progress will be lost unless saved.')) {
        this.$store.commit('resetState')
        this.$bvModal.hide('modal-save-manager')
      }
    },
    closeModal() {
      this.$bvModal.hide('modal-save-manager')
    }
  }
}
</script>

<style scoped>
.list-group-item strong {
  color: #fff;
}
</style>
